module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./DashLights.js"));
	}, "DashLights");
}